<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="1000px"
    >
        <v-card>
            <v-card-title style="padding-bottom: 0;">
                Buscar Factura
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" lg="10" md="10" sm="9">
                        <v-text-field
                            v-model="nombrex"
                            type="text"
                            label="Buscar Factura"
                            placeholder="Buscar Factura"
                        />
                    </v-col>
                    <v-col cols="12" lg="2" md="2" sm="2">
                      <v-btn
                        :color="themeColor"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="mifuncion"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col
                        cols="12"
                    >
                        <vuetify-table-invoice
                            :headers="headers"
                            :api-u-r-l="apiURL"
                            :readonly="true"
                            :title="'Facturas'"
                            :query-params="queryParams"
                            :refresh="refresh"
                        >
                            <template v-slot:actions="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            :color="themeColor"
                                            dark
                                            @click="copySave(item)"
                                            v-on="on"
                                            :loading="busy"
                                        >
                                        mdi-content-save
                                        </v-icon>
                                    </template>
                                    <span>Copiar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            :color="themeColor"
                                            dark
                                            @click="selectItem(item)"
                                            v-on="on"
                                            :loading="busy"
                                        >
                                        mdi-file-edit
                                        </v-icon>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                            </template>
                        </vuetify-table-invoice>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="red darken-1"
                    text
                    @click="cancelAdditionFields"
                >
                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTableInvoice from '~/components/Invoice/VuetifyTableInvoice';

export default {
    middleware: 'auth',
    props: {
        dialog: {
            required: true,
        },
        counterid: {
            required: true,
        },
    },
    components: {
        VuetifyTableInvoice,
    },
    data: () => ({
        headers: [
            {
                text: 'Nº de Documento',
                value: 'document_number',
                align: 'left',
                sortable: true,
            },
            {
                text: 'Nº de control',
                value: 'control_number',
                align: 'left',
                sortable: true,
            },
            {
                text: 'Serie',
                value: 'serie',
                align: 'left',
                sortable: true,
            },
            {
                text: 'Nombre',
                value: 'receiver_name',
                align: 'left',
                sortable: true,
            },
            {
                text: 'Acciones',
                value: 'actions',
                sortable: false,
            },
        ],
        busy: false,
        items: [],
        totalItems: 0,
        InvoceSearch: '',
        nombrex: '',
        queryParams: '',
        apiURLBase: 'api/documents/getinvocesart',
        documentType: '01',
        refresh: true,
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user',
            themeColor: 'theme/themeColor',
        }),
        // queryParams() {
        //     return `&type=${this.documentType}&invoceSearch=${this.nombrex}`;
        // },
        apiURL() {
            return `${this.apiURLBase}`;
        },

    },
    methods: {
        cancelAdditionFields() {
            // this.dialog = false;
            this.$emit('chageShowDialogInvoice', false);
        },
        mifuncion() {
            this.queryParams = `&invoceSearch=${this.nombrex}`;
        },
        copySave(item) {
            this.busy = true;
            const url = 'api/documents/getinvocesart/copy';
            window.axios.post(url, {
                counterId: `${this.counterid}`,
                copyItem: item.id,
            }).then((response) => {
                if (response.data) {
                    this.$store.dispatch('notifications/show', {
                        message: response.data.message,
                        type: 'success',
                    });
                    this.$emit('saveShowDialogInvoice');
                    // this.item = item;
                } else {
                    this.$store.dispatch('notifications/show', {
                    message: 'Error',
                    type: 'error',
                    });
                }
                this.busy = false;
                this.dialogGeneralAction = false;
            })
            .catch(() => {
            });
        },
        selectItem(item) {
            const editedItem = item.id;
            const counterid = `${this.counterid}`;
            this.$router.push({ path: `${this.$router.currentRoute.path}/${editedItem}/create`,
                 params: { counterId: counterid, copyItem: editedItem } });
        },
    },
};
</script>

<style>
</style>
